var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polyline, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect, _polygon, _polygon2, _polygon3, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSectionSvg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#ebcded;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:2px;}.cls-2{stroke-width:4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.6,600.8s6.6-3.6,11.1-2.6c4.81,1.06,9.11,3.38,14.83,4.25s7.12,1,7.12,1,2.07,0,2.53.42.81.27,1.27.66,1,.58,1.32.85a7,7,0,0,1,1.31,3,54.32,54.32,0,0,1,2.2,10.39s-1.27,4.74-2.05,5.13a3.56,3.56,0,0,1-1.54.35,8,8,0,0,1-.58,2c-.46,1-4.44,7.88-6.29,8.3,0,0-.69.39-2.12-1.89a14.42,14.42,0,0,1-9,8.88s-1.66-1.93-1.2-6.72c0,0-3.59,2.59-6.48,2,0,0-.74-2.12.61-7.57,0,0-4.71,1.93-7.1-.07a12.36,12.36,0,0,1,2.32-7s-6.41-1.85-7.8-4.71c0,0,.66-3.7,6.49-7.6C122.55,610,116.49,608.53,115.6,600.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.55,610s3-.56,15.78-1.78c0,0-3.94-1-3.82-4.25,0,0-.23-1.45,9,1.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.86,622.28a94.47,94.47,0,0,1,14.06-9.18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.65,603.49a21.82,21.82,0,0,1-2.62.43c-1.08.08-2.65,0-2.65.64s.56,2,2.21,1.12,2.07-1.13,5.59-1.77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.84,604.84c-5.56,1.53-6.37,3.13-6.37,3.13-2.49.52-1.34-2.09-1.34-2.09s-4.23.07-6.8,2.31-2.74,3.17-2.74,3.17-.08,2,4.14,1.74a9.69,9.69,0,0,1,3.65-2.9,7,7,0,0,0,3.09-2.23s-.32,2.27,1.93,2c0,0,1.1-2.83,5.77-4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.4,610s0,2.42,1.91,1.53a4,4,0,0,1,1.14-2.2c.93-.77,3.18-2.29,3.18-2.29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.31,611.5s0,1.89.58,1.89,2.53.66,4.05-5.41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.73,613.1s-1,1.59-.48,2.18,4.41,0,4.41,0-7.58,6.86-11.12,9.87-3.9,4.19-3.9,4.19"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.4,610.44a35.58,35.58,0,0,0-4.74,4.84,4.78,4.78,0,0,0-1.16,2.18,7.9,7.9,0,0,0,0,1.57s-.24.68,3.09.3c0,0-7.83,10.44-9.44,12.61s-1.64,3-1.64,3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.31,612.13a28.81,28.81,0,0,0-3.8,5.17c-.92,2-1.12,3.74-.6,3.92s5.46-.61,7.49-9.23"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.82,611.24s1.3,7.78-.13,13.09"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.5,620.88a34.41,34.41,0,0,1-1.87,6c-1.28,3-1.58,3.33-.93,5.88"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.28,618.85l3.08-4.75s17.66-17.37,32.87-18.38,32.87,20.9,32.87,20.9-25.26,11-29,20.16c0,0-12.2,18.51-18,32l-.68-.21s-9.84,12.37-29.85,19.2c0,0-14.86-14.54-18.12-17.08s-9.89-7.7-14.69-9.13c0,0,19.9-7.15,27.76-17.16l0-1.21L151,630"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.82,661.56s-1.33,8.25,5.47,11.74,13.21,6.28,28.12,22.16l5.1,5.09s20.68-12.21,29.72-29.62c0,0-3.4-.73-5.07-2.15"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.63,687.77s-.86,7,2.41,9.32"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "184.23 670.93 185.3 670.93 188.65 665.21"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189,659.44s-2.14,3.07-2.14,4.89a12.08,12.08,0,0,0,5.54,2.14s7.31-4.89,9.83-6.15c0,0-1.54-1.54.71-3.57s5.11-4.45,6.26-4.78a7.8,7.8,0,0,1,2.86,0s-.06-.93,1.48-1.92a8.83,8.83,0,0,1,2.53-1.21,20.9,20.9,0,0,0-9.89.77"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.26,660.32s.91.8,2.88,0a18.51,18.51,0,0,1,6.93-7.62l0-.73"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.43,666.47a14.22,14.22,0,0,0-5.18,13.09s.81,1.35,5.18,0l.4-2.79a37.55,37.55,0,0,1,4.23-6.92c2.09-2.39,8.36-8.66,8.36-8.66l-.28-.87"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.43,679.56s-.05,6.33.85,6.62,3.53-.19,5.62-1.64c0,0-.15-3.19.85-5s10.05-15.83,10.05-15.83v-.6a14,14,0,0,1-2.63.9c-.55,0-1.75-2.84-1.75-2.84"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.9,684.54s.4,6.92,2.22,6.92,5.25-2.79,5.25-2.79-.45-2.68,0-3.78,7.12-18,7.12-18v-.45a5.7,5.7,0,0,1-2.29,0c-.55-.3-1.4-2.74-1.4-2.74"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.1,655.61c1.61,2.64,2.87,11.46,2.87,11.46s-2.44,5.37-3.48,5.37c-1.94-.5-5.58-4.83-5.58-4.83v-.89a9,9,0,0,1-1.94,1.49,6,6,0,0,1-3.73.6c-.45,0-.75-1.89-.75-1.89"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.37,688.67s2.44,8.12,4.48,8,5.63-4,7-6.47a8.08,8.08,0,0,1-.9-2.69c0-1,1-19.27,1-19.27"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229,667.07s3.45,13.51,2.49,20-3.82,10.73-5.36,10.73-4.76-2-8.23-7.66"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.07,652.7s0,1.55.89,1.72a4.63,4.63,0,0,0,1.68,0s-.72-2.09.86-3,4.93-2.56,4.93-2.56l-4.33,0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.64,654.42s.44,1.17,2.29.79a6.77,6.77,0,0,1,5.76-5.14s.1-1-2.26-1.26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.69,650.07s1.47.41,1.44,1.37c0,0-4,1.26-3.19,6.08a5,5,0,0,1-2,.33c-.75-.14-1.85-1.61-2-2.64"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.13,651.44a2.28,2.28,0,0,1,2,2.23v1.94s1.86,5.06-1.56,5.06c-3,0-3.6-3.15-3.6-3.15"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.8,663.13a8.33,8.33,0,0,1-.2-2.46c.21-.49,4.32-6.17,4.32-6.17"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.49,666.47a14,14,0,0,1-.26-3.34c.24-.45,4-7.07,4-7.07"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.91,666.72s1.17-6.06,1.59-7.77"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.62,639.31s7.9-6.88,23.48-7c0,0,2.06-11.24,0-15.64"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.58,644.4s31,22.63,34.9,24.17"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.36,614.1s29.9,19.23,36.75,22.68l6.07,2.79-4.72,9.23s-5.59-3.36-8.72,3.83c0,0-1.86,2.42-.71,6.81a30.41,30.41,0,0,1,17.18-9.83c-5.54.83-7.75-.81-7.75-.81"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.23,644.9c4.52-8.29.65-11.5.65-11.5s-4.79-4.75-10.53,1.83c-.54.63-1.06,1.18-1.54,1.67l-5.43-3.81a5.92,5.92,0,0,1,3.87-1L168,627c-3.51-1.22-7.2.76-9.86,3.84l-.89-.63-2,2.71.94.66c-2.24,3.94-2.79,8.52.05,10.81,4.24,3.42,9,.16,11.74-2.53l5.37,3.78c-3,2-5.08,1-5.08,1l-3.06,5.26c2.49,1.14,7,1.3,11.15-4.1l2.44,1.72,1.92-2.81Zm-18.33-4.78c-.47-.26-1.34-1.6-.41-4.24l4.7,3.3C161.48,641.08,160.26,640.32,159.9,640.12Zm10.36-.8c.84-1.23,3.31-2.54,4.81-1.6,1,.63,1.28,3.09.42,5.25Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M637.78,563H400.4c-1.11-19.92,9.84-28.77,9.84-28.77h18.92l1.11-63.09h32.08l35.43-39.82V402.58h-5.56V380.44c-88.51-15.5-81.88-198.08-81.88-198.08C448,165.78,519.07,168,519.07,168s71.12-2.21,108.73,14.37c0,0,6.63,182.58-81.88,198.08v22.14h-5.53v28.76l35.4,39.82h32.08L609,534.25h18.95S638.88,543.1,637.78,563Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.71,242.39s19.38,2.79,20.48-22c0,0-10.52-26.91-40.4-21.93,0,0-46.06,6.41-42.74,44.08S409,324.14,409,324.14s15.77,7.47-6.23,8.71c0,0-8.3,13.28,8.72,11.21s21.15-19.62,21.15-19.62-74.27-61.71-74.27-80.39c0,0-.41-18.67,24.9-20.33C383.24,223.72,408.14,222.06,390.71,242.39Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647.44,242.39s-19.37,2.79-20.47-22c0,0,10.52-26.91,40.39-21.93,0,0,46.06,6.41,42.74,44.08s-80.91,81.65-80.91,81.65-15.77,7.47,6.22,8.71c0,0,8.3,13.28-8.71,11.21s-21.16-19.62-21.16-19.62,74.27-61.71,74.27-80.39c0,0,.42-18.67-24.9-20.33C654.91,223.72,630,222.06,647.44,242.39Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 461.74,
    y: 738.28,
    width: 115.95,
    height: 115.95,
    rx: 20
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "484.05 792.46 498.39 792.46 513.53 815.57 545.41 760.19 560.55 760.19 513.53 838.28 484.05 794.46 482.7 792.48 484.05 792.46"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "866.01 645.3 826.75 672.93 875.6 662.75 877.06 698.81 903.52 655.48 954.12 700.55 923.59 645.3 954.12 635.7 926.2 624.94 945.4 574.34 915.15 603.42 906.14 573.18 896.25 601.68 863.68 568.82 876.18 604.88 855.83 598.19 866.88 613.89 822.09 607.49 863.1 632.79 831.4 643.55 866.01 645.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "881.92 640.96 858.69 657.31 887.6 651.29 888.46 672.62 904.12 646.99 934.06 673.66 915.99 640.96 934.06 635.29 917.54 628.92 928.89 598.98 911 616.19 905.67 598.29 899.82 615.15 880.54 595.71 887.94 617.05 875.9 613.09 882.44 622.38 855.94 618.6 880.2 633.57 861.45 639.93 881.92 640.96"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "893.1 637.61 882.28 645.23 895.75 642.42 896.15 652.36 903.44 640.42 917.39 652.84 908.97 637.61 917.39 634.97 909.7 632 914.99 618.05 906.65 626.07 904.16 617.73 901.44 625.59 892.46 616.53 895.91 626.47 890.3 624.62 893.34 628.95 881 627.19 892.3 634.16 883.56 637.13 893.1 637.61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionSvg2);
export default __webpack_public_path__ + "static/media/sectionSvg2.8f98ef7e0f08aedd8d9c4df5cc932efe.svg";
export { ForwardRef as ReactComponent };